import React from "react";

import "./index.scss";
import { SMailIcon } from "../../assets/icons/SMailIcon";
import { SLocalisationIcon } from "../../assets/icons/SLocalisationIcon";
import { SFileIcon } from "../../assets/icons/SFileIcon";
import { SphoneIcom } from "../../assets/icons/SphoneIcom";

const StickyButtons = () => {
  return (
    <div className="sticky-btns">
      <a href="tel:24522142554">
        <div className="btn-icon  phone-btn">
          <span className="phone-number">01 71 36 24 89</span>
          <SphoneIcom />{" "}
        </div>{" "}
      </a>
      <a href="mailto:contact@habitat-idf.fr">
        <div className="btn-icon">
          {" "}
          <SMailIcon />
        </div>{" "}
      </a>
      <a
        href="https://www.google.com/maps?q=36.8065,10.1815"
        target="_blank"
        rel="noopener noreferrer"
        className="location-link">
        <div className="btn-icon">
          <SLocalisationIcon />
        </div>
      </a>
      <a href="/contact">
        {" "}
        <div className="btn-icon">
          <SFileIcon />
        </div>
      </a>
    </div>
  );
};

export default StickyButtons;
